import TitleHeader from "@/components/TitleHeader";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  Text,
  Image,
  Input,
} from "@chakra-ui/react";
import { useUserInfo } from "@/context/UserInfo";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import { CURRENCY_LIST } from "@/constants/currencys";
import { useState } from "react";

const ReceiveCurrencyModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { currencyUnit } = useCurrencyExchange();
  const { handleSetCurrency } = useUserInfo();
  const [searchValue, setSearchValue] = useState("");

  const filteredCurrency = CURRENCY_LIST.filter((item) => {
    const searchTerms = searchValue.toLowerCase().split(" ");
    const countryName = item.name.toLowerCase();

    return searchTerms.every((term) => {
      let lastIndex = -1;
      return term.split("").every((char) => {
        lastIndex = countryName.indexOf(char, lastIndex + 1);
        return lastIndex !== -1;
      });
    });
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalContent>
        <ModalBody
          sx={{
            height: "100%",
            padding: "0",
            width: "100%",
          }}
        >
          <Box sx={{ padding: "20px" }}>
            <TitleHeader title="Currency" color="#D8762B" onBack={onClose} />
          </Box>
          <Box sx={{ padding: "0 30px" }}>
            <Text>Search country</Text>
            <Input
              variant="unstyled"
              placeholder="input to search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              sx={{
                margin: "6px 0",
                fontSize: "14px",
                height: "20px",
                "&::placeholder": {
                  color: "#999",
                },
              }}
            />
          </Box>
          <Flex
            sx={{
              height: "calc(100vh - 64px)",
              width: "100%",
            }}
          >
            <Flex
              sx={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                }}
              >
                {filteredCurrency.map((item) => (
                  <Flex
                    key={item.currency}
                    sx={{
                      height: "45px",
                      background:
                        currencyUnit === item.currency ? "#FFD7AC" : "#fff",
                      padding: "0 30px",
                    }}
                    align={"center"}
                    onClick={() => {
                      handleSetCurrency(item.currency, true);
                      onClose();
                    }}
                  >
                    <Image
                      src={`https://images-country.meld.io/${item.countryCode}/flag.svg`}
                      sx={{
                        width: "30px",
                        height: "30px",
                        marginRight: "12px",
                        borderRadius: "50%",
                      }}
                      fallback={
                        <Box
                          width="30px"
                          height="30px"
                          bg="gray.200"
                          borderRadius="50%"
                        />
                      }
                    ></Image>
                    <Text
                      sx={{
                        marginRight: "15px",
                        color: "#333",
                      }}
                    >
                      {item.currency}
                    </Text>
                    <Text
                      sx={{
                        color: "#848484",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      {item.name}
                    </Text>
                  </Flex>
                ))}
              </Box>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReceiveCurrencyModal;
